import MitraTypes from '../Types/MitraTypes';

import { formatError } from '../../services/AppService';
import { getMitraDetails } from '../../services/API/MitraService';
import { getUserDetailsById } from '../../services/API/MarketplaceService';

const DEFAULT_TIMEOUT = 5000;

export default function(state, dispatch) {
  function _dispatch(type, payload) {
    dispatch({ type, payload });
  }
  function _dispatchAPIProgress(status) {
    _dispatch(MitraTypes.IS_API_PROGRESS, status);
  }

  const _resetError = () => {
    _dispatch(MitraTypes.RESET_ERROR);
  };

  const setError = (error, isAutoCancel = true, timeout) => {
    dispatch(MitraTypes.SET_ERROR, { error: formatError(error) });
    if (isAutoCancel) {
      setTimeout(() => {
        _resetError();
      }, timeout || DEFAULT_TIMEOUT);
    }
  };

  const fetchMitraDetailById = id => {
    _dispatchAPIProgress(true);
    getMitraDetails(id)
      .then(mitraDetails => {
        _dispatch(MitraTypes.SET_MITRA_DETAILS, mitraDetails);
      })
      .catch(error => {
        setError(error);
      })
      .finally(() => {
        _dispatchAPIProgress(false);
      });
  };

  const fetchMarketplaceMitraDetails = id => {
    _dispatchAPIProgress(true);
    getUserDetailsById(id)
      .then(mitraDetails => {
        _dispatch(MitraTypes.SET_MITRA_DETAILS, mitraDetails.data);
      })
      .catch(error => {
        setError(error);
      })
      .finally(() => {
        _dispatchAPIProgress(false);
      });
  };

  const setSelectedJobDescription = data => {
    _dispatch(MitraTypes.SET_JOB_DESCRIPTION, data);
  };

  const setJobListingsCarouselContent = data => {
    _dispatch(MitraTypes.SET_JOB_DESCRIPTION, data);
  };

  return {
    setError,
    fetchMitraDetailById,
    fetchMarketplaceMitraDetails,
    setSelectedJobDescription,
    setJobListingsCarouselContent,
  };
}
